(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("globalizationService", ["$http", globalizationService]);
    function globalizationService($http) {
        var factory = {
            load: load
        };
        function load(code, successCallback) {
            if (code === "CAN" || code === "USA") {
                $http.get("/app/i18n/globalization/" + code + ".json", { cache: true }).then(function (result) {
                    successCallback(result.data);
                });
            }
            else {
                $http.get("/app/i18n/globalization/default.json", { cache: true }).then(function (result) {
                    successCallback(result.data);
                });
            }
        }
        return factory;
    }
}());
